<template>
  <!-- Modal -->
        <div class="modal fade" id="modalLogin" tabindex="-1" role="dialog" aria-labelledby="addNew" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" ><i class="fas fa-user"> </i> Cadastro </h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <form  @submit.prevent="novoCadastro?fazerCadastro():redefinirSenha?redefinirSenhaEnviar(redefinirSenhaStatus):fazerLogin()">
                    <div class="modal-body" v-if="!carregando">

                        <div class="card text-center">
                            <div class="card-header">
                                <ul class="nav nav-pills">
                                    <li class="nav-item">
                                        <a href="#fazer-login" class="nav-link active show" data-toggle="tab"  v-on:click="novoCadastro = false, redefinirSenha = false,redefinirSenhaStatus=0, resetarForms()" >Fazer Login</a>
                                    </li>
                                    <li class="nav-item">
                                        <a href="#fazer-cadastro" class="nav-link" data-toggle="tab" v-on:click="novoCadastro = true, redefinirSenha = false,resetarForms()">Novo Cadastro</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="card-body">
                                <div class="tab-content">
                                    <div class="tab-pane" id="activity">
                                        <h3 class="text-center">Display User Activity</h3>
                                    </div>
                                    <div id="fazer-login" class="tab-pane active show">
                                        <div v-if="!redefinirSenha">

                                            <h4>Entre com seu Telefone</h4>
                                            <alert-error :form="form" />
                                            <div class="form-group">
                                                <the-mask
                                                    :mask="['(##) ####-####', '(##) #####-####']"
                                                    :masked="true"
                                                    v-model="form.fone"
                                                    type="text" name="fone"
                                                    inputmode="numeric"
                                                    class="form-control form-control-lg"
                                                    placeholder="Digite seu Telefone"
                                                    :class="{ 'is-invalid': form.errors.has('error') }"
                                                />

                                            </div>
                                            <!-- <div class="form-group">
                                                <input
                                                    v-model="form.password"
                                                    type="password"
                                                    class="form-control form-control-lg"
                                                    placeholder="Digite sua Senha"
                                                    :class="{ 'is-invalid': form.errors.has('error') }"
                                                >
                                            </div>
                                            <a href="#" v-on:click="redefinirSenha = true, redefinirSenhaStatus=1">Esqueci a senha</a> -->

                                        </div>
                                        <div v-else>

                                            <div v-if="redefinirSenhaStatus==1">
                                                <!-- TELA DE REDEFINIR SENHA - ENVIAR NUMERO -->
                                                <h4>Redefinir Senha</h4>
                                                <p>Digite seu telefone cadastrado parar receber o código de redefinição de senha.</p>
                                                <div class="form-group">
                                                    <the-mask
                                                        :mask="['(##) ####-####', '(##) #####-####']"
                                                        :masked="true"
                                                        v-model="formRedefinir.fone"
                                                        type="text" name="fone"
                                                        inputmode="numeric"
                                                        class="form-control form-control-lg"
                                                        placeholder="Digite seu Telefone"
                                                        :class="{ 'is-invalid': formRedefinir.errors.has('fone') }"
                                                    />
                                                    <has-error :form="formRedefinir" field="fone"></has-error>

                                                </div>
                                                <P>Como deseja receber o código?</P>

                                                <div class="form-check my-3">
                                                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="option1" disabled>
                                                    <label class="form-check-label" for="exampleRadios1">
                                                        Receber por SMS
                                                    </label>
                                                </div>
                                                <div class="form-check my-3">
                                                    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="option2" checked>
                                                    <label class="form-check-label" for="exampleRadios2">
                                                        Receber por Whatsapp
                                                    </label>
                                                </div>

                                            </div>
                                            <div v-if="redefinirSenhaStatus==2">
                                                <!-- TELA DE REDEFINIR SENHA - ENVIAR CODIGO -->
                                                <h4>Digite o código recebido no seu Whatsapp</h4>
                                                <p>Código enviado para: {{formRedefinir.fone}}</p>
                                                <div class="form-group">
                                                    <input
                                                        v-model="formRedefinir.codigo"
                                                        type="text"
                                                        inputmode="numeric"
                                                        class="form-control form-control-lg"
                                                        placeholder="CÓDIGO"
                                                        :class="{ 'is-invalid': formRedefinir.errors.has('codigo') }"
                                                    >
                                                    <has-error :form="formRedefinir" field="codigo"></has-error>

                                                </div>
                                            </div>
                                            <div v-if="redefinirSenhaStatus==3">
                                                <!-- TELA DE REDEFINIR SENHA - ENVIAR NOVA SENHA -->
                                                <h4>Digite sua nova Senha</h4>

                                                <div class="form-group">
                                                    <input
                                                        v-model="formRedefinir.password"
                                                        type="password"
                                                        class="form-control form-control-lg"
                                                        placeholder="Digite sua Senha"
                                                        :class="{ 'is-invalid': formRedefinir.errors.has('password') }"
                                                    >
                                                </div>
                                                <div class="form-group">
                                                    <input
                                                        v-model="formRedefinir.password_confirmation"
                                                        type="password"
                                                        class="form-control form-control-lg"
                                                        placeholder="Repita a sua Senha"
                                                        :class="{ 'is-invalid': formRedefinir.errors.has('password') }"
                                                    >
                                                    <has-error :form="formRedefinir" field="password"></has-error>
                                                </div>
                                            </div>


                                        </div>


                                    </div>
                                    <div id="fazer-cadastro" class="tab-pane">
                                        <h4>Novo Cadastro</h4>

                                        <div class="form-group">
                                            <input
                                                v-model="formCadastro.name"
                                                type="text"
                                                class="form-control form-control-lg"
                                                placeholder="Digite seu nome"
                                                :class="{ 'is-invalid': formCadastro.errors.has('name') }"
                                            >
                                            <has-error :form="formCadastro" field="name"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <input
                                                v-model="formCadastro.email"
                                                type="email"
                                                class="form-control form-control-lg"
                                                placeholder="Digite seu e-mail"
                                                :class="{ 'is-invalid': formCadastro.errors.has('email') }"
                                            >
                                            <has-error :form="formCadastro" field="email"></has-error>
                                        </div>

                                        <div class="form-group">
                                            <the-mask
                                                :mask="['(##) ####-####', '(##) #####-####']"
                                                :masked="true"
                                                v-model="formCadastro.fone"
                                                type="text" name="fone"
                                                inputmode="numeric"
                                                class="form-control form-control-lg"
                                                placeholder="Digite seu Telefone"
                                                :class="{ 'is-invalid': formCadastro.errors.has('fone') }"
                                            />
                                            <has-error :form="formCadastro" field="fone"></has-error>

                                        </div>
                                        <div class="form-group">
                                            <input
                                                v-model="formCadastro.password"
                                                type="password"
                                                class="form-control form-control-lg"
                                                placeholder="Digite sua Senha"
                                                :class="{ 'is-invalid': formCadastro.errors.has('password') }"
                                            >
                                        </div>
                                        <div class="form-group">
                                            <input
                                                v-model="formCadastro.password_confirmation"
                                                type="password"
                                                class="form-control form-control-lg"
                                                placeholder="Repita a sua Senha"
                                                :class="{ 'is-invalid': formCadastro.errors.has('password') }"
                                            >
                                            <has-error :form="formCadastro" field="password"></has-error>
                                        </div>
                                    </div>

                                </div>



                            </div>
                        </div>



                    </div>

                    <div v-else class="text-center">
                        <div class="spinner-border text-info my-5" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>



                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <button type="submit" class="btn h-btn" v-if="novoCadastro">Cadastrar</button>
                        <template v-else>
                            <button type="submit" class="btn h-btn" v-if="redefinirSenhaStatus==1" >enviar</button>
                            <button type="submit" class="btn h-btn" v-if="redefinirSenhaStatus==2" >enviar codigo</button>
                            <button type="submit" class="btn h-btn" v-if="redefinirSenhaStatus==3" >redefinir Senha</button>
                            <button type="submit" class="btn h-btn" v-if="redefinirSenhaStatus==0" >Entrar</button>

                        </template>
                    </div>
                  </form>
                </div>
            </div>
        </div>
</template>

<script>
import api from "../service/api";
import Cookie from "js-cookie";

export default {
    data () {
        return {
            carregando:false,
            novoCadastro:false,

            redefinirSenha:false,
            telefoneOk:false,
            codigoOk:false,
            redefinirSenhaStatus:0,

            form: new Form({
                fone : '',
                password: '',
            }),

            formRedefinir: new Form({
                fone : '',
                codigo: '',
                password: '',
                password_confirmation: '',
            }),

            formCadastro: new Form({
                name:'',
                fone : '',
                email: '',
                password: '',
                password_confirmation: '',
                codigo: '',

            }),
        }
    },

    watch: {

    },

    methods: {

        resetarForms(){
            this.form.reset();
            this.form.errors.errors = {};
            this.formRedefinir.reset();
            this.formRedefinir.errors.errors = {};
            this.formCadastro.reset();
            this.formCadastro.errors.errors = {};
            this.redefinirSenha = false;
            this.redefinirSenhaStatus = 0;
        },

        async redefinirSenhaEnviar(cod){
            if (cod==1) {
                this.carregando = true;
                await this.formRedefinir.post('/api/login-user/redefinir-senha-wp')
                .then((response) => {
                    if (response.data.success) {
                        this.redefinirSenhaStatus=2
                    }else{
                        Toast.fire({
                            icon: 'error',
                            title: response.data.error
                        });
                    }
                })
                .catch(() => {
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
                });
                this.carregando = false;
            }
            if (cod==2) {
                this.carregando = true;
                await this.formRedefinir.post('/api/login-user/redefinir-senha/codigo')
                .then((response) => {
                    if (response.data.success) {
                        this.redefinirSenhaStatus=3
                    }else{
                        Toast.fire({
                            icon: 'error',
                            title: response.data.error
                        });
                    }
                })
                .catch(() => {
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
                });
                this.carregando = false;
            }
            if (cod==3) {
                this.carregando = true;
                await this.formRedefinir.post('/api/login-user/redefinir-senha/atualizar')
                .then((response) => {
                    Cookie.set('token',response.data.access_token );
                    localStorage.setItem('token', response.data.access_token);
                    this.carregarPerfil();

                    this.resetarForms();

                    Swal.fire({
                        icon: 'success',
                        title: 'Login Efetuado com Sucesso',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    const pagina = Cookie.get('proximaPagina');


                    switch (pagina) {
                        case 'perfil':
                            $('#modalLogin').modal('hide');
                            this.$router.push("/site/perfil");
                            break;

                        case 'finalizarCompra':
                            $('#modalLogin').modal('hide');
                            setTimeout(function() {
                                $('#modalFinalizarCompra').modal('show')
                            }, 400);

                            break;

                        default:
                            break;
                    }
                })
                .catch(() => {
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
                });
                this.carregando = false;
            }
        },

        fazerLogin(){
            this.carregando = true;
            this.form.post('/api/login-user')
            .then((response) => {

                if (!response.data.error) {
                    Cookie.set('token',response.data.access_token );
                    localStorage.setItem('token', response.data.access_token);
                    this.carregarPerfil();

                    this.form.reset();

                    Swal.fire({
                        icon: 'success',
                        title: 'Login Efetuado com Sucesso',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    const pagina = Cookie.get('proximaPagina');


                    switch (pagina) {
                        case 'perfil':
                            $('#modalLogin').modal('hide');
                            this.$router.push("/site/perfil");
                            break;

                        case 'finalizarCompra':
                            $('#modalLogin').modal('hide');
                            setTimeout(function() {
                                $('#modalFinalizarCompra').modal('show')
                            }, 400);

                            break;

                        default:
                            break;
                    }




                }else{

                    Toast.fire({
                        icon: 'error',
                        title: response.data.error
                    });

                    // this.$Progress.failed();
                }

            })
            .catch(() => {
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
            });

            this.carregando = false;

        },

        fazerCadastro(){
            this.carregando = true;
            this.formCadastro.post('/api/register-user')
            .then((response) => {

                if (!response.data.error) {
                    Cookie.set('token',response.data.access_token );
                    localStorage.setItem('token', response.data.access_token);
                    this.carregarPerfil();
                    $('#modalLogin').modal('hide');
                    this.form.reset();

                    Swal.fire({
                        icon: 'success',
                        title: 'Login Efetuado com Sucesso',
                        showConfirmButton: false,
                        timer: 1500
                    });

                    const pagina = Cookie.get('proximaPagina');

                    switch (pagina) {
                        case 'perfil':
                            this.$router.push("/site/perfil");
                            break;

                        case 'finalizarCompra':
                            $('#modalFinalizarCompra').modal('show');
                            break;

                        default:
                            break;
                    }




                }else{

                    Toast.fire({
                        icon: 'error',
                        title: response.data.error
                    });

                    // this.$Progress.failed();
                }

            })
            .catch(() => {
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
            });

            this.carregando = false;

        },


        testarToken(){

            api.get('/validar')
            .then((response) => {

                if (!response.data.error) {
                    console.log(response.data)


                }else{

                    Toast.fire({
                        icon: 'error',
                        title: response.data.error
                    });

                    // this.$Progress.failed();
                }

            })
            .catch(() => {
                Toast.fire({
                        icon: 'error',
                        title: 'Algo deu errado!'
                    });
            });

        },

        mudar(){
            this.novoCadastro = true;
        },

        carregarPerfil(){
            this.$store.dispatch('fetchPerfil').then();
        }


    },


    mounted() {

    }

}
</script>

<style scoped>

.modal {
    color: #000;
}



.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.nav-pills .nav-link.active, .nav-pills .show > .nav-link {
    color: var(--btntxt1);
    background-color: var(--btnbg1);
}


</style>
